<router-outlet></router-outlet>

<footer class="accordeon-tabs">
  <app-regulation></app-regulation>
  <app-virtual-tour></app-virtual-tour>
  <app-laudatio></app-laudatio>
  <app-impressum></app-impressum>
</footer>